'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const SendVolumeChart = dynamic(() => import('./SendVolumeChart'), { ssr: false });
const OpenRateChart = dynamic(() => import('./OpenRateChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 gap-6">
      <div className="xl:col-span-3 card p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="section-header">Send Volume</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Emails sent per day — last 30 days</p>
          </div>
          <span className="badge bg-primary/10 text-primary">30 days</span>
        </div>
        <SendVolumeChart />
      </div>
      <div className="xl:col-span-2 card p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="section-header">Open Rate Trend</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Daily open rate %</p>
          </div>
          <span className="badge bg-green-100 text-green-700">↑ 2.1%</span>
        </div>
        <OpenRateChart />
      </div>
    </div>
  );
}